import { DifficultyLevelType } from 'constants/difficulty';
import {
  UIActionTypes,
  UIState,
  DesignTab,
  Checkboxes,
  OpenDesignModalAction,
  CloseDesignModalAction,
  SetDesignTabAction,
  OpenSettingsModalAction,
  CloseSettingsModalAction,
  CloseMissionsModalAction,
  ToggleSettingAction,
  UpdateSettingsAction,
  CloseAllPanelsAction,
  OpenMissionCompletePopupAction,
  CloseMissionCompletePopupAction,
  ToggleIsNewMissionAction,
  ShowImagePreviewModalAction,
  CloseImagePreviewModalAction,
  OpenNewGameModalAction,
  CloseNewGameModalAction,
  SetCurrentDifficultyAction,
} from '../../types/gameUI';

export const updateUIState = (payload: Partial<UIState>) => ({
  type: UIActionTypes.UPDATE_UI_STATE,
  payload
} as const);

export const updateTime = (payload: string) => ({
  type: UIActionTypes.UPDATE_TIME,
  payload
} as const);

export const openDesignModal = (tab?: DesignTab): OpenDesignModalAction => ({
  type: UIActionTypes.OPEN_DESIGN_MODAL,
  payload: tab
});

export const closeDesignModal = (): CloseDesignModalAction => ({
  type: UIActionTypes.CLOSE_DESIGN_MODAL
});

export const setDesignTab = (tab: DesignTab): SetDesignTabAction => ({
  type: UIActionTypes.SET_DESIGN_TAB,
  payload: tab
});

export const openSettingsModal = (): OpenSettingsModalAction => ({
  type: UIActionTypes.OPEN_SETTINGS_MODAL
});

export const closeSettingsModal = (): CloseSettingsModalAction => ({
  type: UIActionTypes.CLOSE_SETTINGS_MODAL
});

export const closeMissionsModal = (): CloseMissionsModalAction => ({
  type: UIActionTypes.CLOSE_MISSIONS_MODAL
});

export const closeAllPanels = (): CloseAllPanelsAction => ({
  type: UIActionTypes.CLOSE_ALL_PANELS
});

export const toggleIsNewMission = (value: boolean): ToggleIsNewMissionAction => ({
  type: UIActionTypes.TOGGLE_IS_NEW_MISSION,
  payload: value
});

// Settings Actions
export const toggleSetting = (key: string): ToggleSettingAction => ({
  type: UIActionTypes.TOGGLE_SETTING,
  payload: key
});

export const updateSettings = (settings: Checkboxes[]): UpdateSettingsAction => ({
  type: UIActionTypes.UPDATE_SETTINGS,
  payload: settings
});

export const openMissionCompletePopup = (placement: 'winscreen' | 'sidebar'): OpenMissionCompletePopupAction => ({
  type: UIActionTypes.OPEN_MISSION_COMPLETE_POPUP,
  payload: placement
});

export const closeMissionCompletePopup = (): CloseMissionCompletePopupAction => ({
  type: UIActionTypes.CLOSE_MISSION_COMPLETE_POPUP
});

export const showImagePreviewModal = (data: {
  id: number;
  storyName: string;
  placement?: 'bottom_sticky_button' | 'congratulations';
  images: { src: string; isUnlocked: boolean; alt: string, previewText?: {
    titleKey: string;
    textKey: string;
} }[];
  initialSlideIndex: number;
}): ShowImagePreviewModalAction => ({
  type: UIActionTypes.SHOW_IMAGE_PREVIEW_MODAL,
  payload: data
});

export const closeImagePreviewModal = (): CloseImagePreviewModalAction => ({
  type: UIActionTypes.CLOSE_IMAGE_PREVIEW_MODAL
});

export const openNewGameModal = (): OpenNewGameModalAction => ({
  type: UIActionTypes.OPEN_NEW_GAME_MODAL
});

export const closeNewGameModal = (): CloseNewGameModalAction => ({
  type: UIActionTypes.CLOSE_NEW_GAME_MODAL
});

export const setCurrentDifficulty = (difficulty: {type: DifficultyLevelType, dataDraw?: string, dataSuit?: string}): SetCurrentDifficultyAction => ({
  type: UIActionTypes.SET_CURRENT_DIFFICULTY,
  payload: difficulty
});
